import { Component, OnInit } from '@angular/core';

import { CurrentUserService, HeaderAvatarService } from '@shared/services';
import { Users } from '@shared/api/users/users.model';

@Component({
  selector: 'app-header-user-avatar',
  templateUrl: './header-user-avatar.component.html',
  styleUrls: ['./header-user-avatar.component.scss']
})
export class HeaderUserAvatarComponent implements OnInit {
  usersInfo: Users;
  usersInitial: string = '';
  isHasPhoto: boolean = false;

  constructor(
    private _currentUser: CurrentUserService,
    private _headerService: HeaderAvatarService
  ) {
    this.usersInfo = this._currentUser.getUserInfo();
    this.isHasPhoto = !!(this.usersInfo && this.usersInfo.imageStream) || false;

    this._headerService.update.subscribe(avatarChange => {
      if (avatarChange) {
        this.usersInfo = this._currentUser.getUserInfo();
        this.isHasPhoto =
          !!(this.usersInfo && this.usersInfo.imageStream) || false;
      }
    });
  }

  ngOnInit() {
    this.getInitial();
  }

  getInitial() {
    if (this.usersInfo) {
      const { firstName, lastName } = this.usersInfo;
      this.usersInitial = `${firstName[0]}${lastName[0]}`;
    }
  }
}
